export default {
    overtimeRequest: 'Overtime request',
    close: 'Close',
    cancel: 'Cancel',
    save: 'Save',
    approve: 'Approve',
    reject: 'Reject',
    profile: 'Profile',
    name: 'Name',
    employeeNo: 'Employee NO',
    group: 'Group',
    department: 'Department',
    requestStatus: 'Request Status',
    contact: 'Contact',
    email: 'Email Address',
    phoneNumber: 'Phone Number',
    dateOfOvertimeWork: 'Date of overtime work',
    timeOfOvertimeWork: 'Time of overtime work',
    reason: 'Reason',
    headDepartmentApproval: 'Head Department Approval',
    adminApproval: 'Administrator Approval',
    congratulation: 'Congratulation',
    errorMessage: 'Error Message',
    otRequestCannotApprove: 'This overtime request cannot be approved due to',
    otExisted: 'Overlap with overtime request of date',
    otOverlap: 'Overlap with others overtime request',
    specialWorkdayOverlap: 'Overlap with special workday',
    timeTableOverlap: 'Overlap with timetable',
    pastTimeTableOverlap: 'Overlap with past schedule'
}
